
import { defineComponent, inject, onMounted, ref } from 'vue'

//import service
import pservice from '@/core/services/PublicService';
import { useRoute } from 'vue-router';

export default defineComponent({
    name: "sports",
    setup() {
        const route = useRoute();
        const { id } = route.params
        const evento = ref<any>({})
        const listSports = ref<any>([])

        const getEvent = async () => {
            await pservice.getDetails(`${id}?type=slug&list=false`)
                .then((res) => {
                    evento.value = res.data
                    getSports()
                }).catch(({ response }) => { })
        }

        const getSports = async () => {
            await pservice.options(evento.value.idevent, 'sports')
                .then((res) => {
                    listSports.value = res.data
                }).catch(({ response }) => { })
        }

        onMounted(() => {
            getEvent()
        })

        return {
            id,
            evento,
            listSports,
            //events
            getSports
        }
    },
})
